"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowLeftIcon = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var iconStyles_1 = require("../../styles/iconStyles");
var descriptionHelper_1 = require("../../utilities/descriptionHelper");
var description = 'ArrowLeftIcon';
var ArrowLeftIcon = function (_a) {
    var _b = _a.styles, styles = _b === void 0 ? '' : _b;
    return (react_1.default.createElement("svg", { className: "".concat((0, descriptionHelper_1.descriptionHelper)(description), " ").concat(styles, " ").concat((0, iconStyles_1.iconStyles)()), "aria-hidden": "true", focusable: "false", role: "img", viewBox: "0 0 448 512" },
        react_1.default.createElement("path", { fill: "currentColor", d: "M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9 .8s8.8 24.8-.8 33.9L83.9 232 424 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L83.9 280 216.6 406.6c9.6 9.2 9.9 24.3 .8 33.9s-24.3 9.9-33.9 .8l-176-168z" })));
};
exports.ArrowLeftIcon = ArrowLeftIcon;
